/**
 * ChatPlan: Rotas do módulo de Changelog
 */
import { frontendURL } from 'dashboard/helper/URLHelper';

const Changelog = () => import('./Changelog.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/changelog'),
    name: 'changelog',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: Changelog,
  },
];

export default { routes };
